import HorizontalNav from './HorizontalNav'

export default HorizontalNav
